import React, { useState, useEffect } from 'react';
import coverImage from '../../assets/img/login.svg';

const ResetPassword = (props) => {

  const [formFields, setFormFields] = useState({ old_password: '', password: '', confirm_password: '' });
  const [isFormValid, setFormValid] = useState(false);

  const signInHandler = () => {
    props.signInSuccess();
  }

  useEffect(() => {
    /** Debouncing */
    const timer = setTimeout(() => {
      let checkForm = true;
      for (const [key, value] of Object.entries(formFields)) {
        if (validateField(key) !== '') {
          checkForm = false;
        }
      }
      setFormValid(checkForm);
    }, 200);
    return () => {
      clearTimeout(timer);
    }
  }, [formFields]);

  const validateField = (name) => {
    let error = '';
    /** Generic test */
    error = formFields[name].length == 0 ? 'Please enter valid value' : '';
    if (name == 'confirm_password') {
      error = formFields[name] !== formFields['password'] ? 'Please enter same password' : '';
    }
    return error;
  }

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const formFieldsObject = {
      ...formFields,
      [name]: value
    }
    setFormFields(formFieldsObject);
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!isFormValid) return;
    alert('Submit Handler');
  }

  return (
    <React.Fragment>
      <div className="unauth-main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-lg-5 pe-0 ps-0">
              <div className="login-left-image">
                <img className="img-fluid" src={coverImage} />
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 pe-0 ps-0">
              <div className="login-form-detail">
                <div className="welcome-title text-center mb-5">
                  <h4>Reset Password</h4>
                  <span>Enter your old password for reset password</span>
                </div>
                <form action="" method="">
                  <div className="mb-3 forms-input">
                    <label className="mb-2">Old Password</label>
                    <input type="password" onChange={handleChange} value={formFields['old_password']} placeholder="Old Password" name="old_password" className="form-control input-min-pass" />
                  </div>
                  <div className="mb-3 forms-input">
                    <label className="mb-2">New Password</label>
                    <input type="password" onChange={handleChange} value={formFields['password']} placeholder="New Password" name="password" className="form-control input-min-pass" />
                  </div>
                  <div className="mb-3 forms-input">
                    <label className="mb-2">Confirm Password</label>
                    <input type="password" onChange={handleChange} value={formFields['confirm_password']} placeholder="Confirm Password" name="confirm_password" className="form-control input-min-pass" />
                  </div>
                  <button type="submit" onClick={submitHandler} className={`btn btn-primary mb-3 ${isFormValid ? 'custom-active' : ''}`}>Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ResetPassword;